//import { ComputeSearchList } from '../../../../models/ComputeSearchList';
import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    item: getDefaultAsyncWrapperObj(),
};
// Action Types
const actionTypesPrefix = 'loadComputeDelete';
export const computeDeleteActionTypes = {
    LOAD: `${actionTypesPrefix}/LOAD`,
    LOADING: `${actionTypesPrefix}/LOADING`,
    LOADED: `${actionTypesPrefix}/LOADOADED`,
};
// Action Creators
export const computeDeleteLoadAction = (payload) => {
    return {
        type: computeDeleteActionTypes.LOAD,
        payload: payload,
    };
};
export const computeDeleteLoadingAction = (payload) => {
    return {
        type: computeDeleteActionTypes.LOADING,
        payload: payload,
    };
};
export const computeDeleteLoadedAction = (payload, result) => {
    return {
        type: computeDeleteActionTypes.LOADED,
        payload: {
            item: result,
        },
    };
};
// Reducer
export const reducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case computeDeleteActionTypes.LOADING:
            return Object.assign(Object.assign({}, state), { item: Object.assign(Object.assign({}, state.item), { status: AsyncRequestStatus.Pending }) });
        case computeDeleteActionTypes.LOADED:
            const loadedAction = action;
            return Object.assign(Object.assign({}, state), { item: loadedAction.payload.item });
        default:
            return state;
    }
};
export default reducer;

//# sourceMappingURL=ComputeDelete.ducks.js.map
